// extracted by mini-css-extract-plugin
export default {"cartPageContainer":"CartPage_cartPageContainer__Ekysb","totalPrice":"CartPage_totalPrice__mNo2l","purchaseBtn":"CartPage_purchaseBtn__X3QIJ"};